// extracted by mini-css-extract-plugin
export var content = "_2g-3";
export var contentWrapper = "_2g-2";
export var fullWidthButton = "_2g-4";
export var heroImage = "_2g-6";
export var logo = "_2g-1";
export var logoContainer = "_2g-0";
export var panel = "_2g-5";